import(/* webpackMode: "eager" */ "/tmp/seed/source/app/(normal)/error.tsx");
